import { render } from "./cardSkeleton.vue?vue&type=template&id=abe01c76&scoped=true"
import script from "./cardSkeleton.vue?vue&type=script&lang=js"
export * from "./cardSkeleton.vue?vue&type=script&lang=js"

import "./cardSkeleton.vue?vue&type=style&index=0&id=abe01c76&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe01c76"]])

export default __exports__